import React from 'react';
import { format as timeago } from 'timeago.js';

const TimeAgo = ({ date }: { date: Date }) => {
  return (
      <span title={date.toLocaleString()}>{date ? timeago(date) : 'Never'}</span>
  );
};

export default TimeAgo;
